import script from "./EditComptable.vue?vue&type=script&setup=true&lang=js"
export * from "./EditComptable.vue?vue&type=script&setup=true&lang=js"

import "./EditComptable.vue?vue&type=style&index=0&id=08a4b763&lang=css"

const __exports__ = script;

export default __exports__